// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"89816fbf","453":"44d9f53c"}[chunkId] + ".chunk.js";
};